import React, { Component } from 'react'
import { connect } from 'react-redux'

import store from '../../../store'

// import styles
import './qualitycheckmodal.scss'

// import components
import Portal from '../../components/Portal'
import Modal from '../../components/Modal'
import Confirm from '../../components/Confirm'

// Modals
import PhotoDocModal from '../PhotoDocModal'

// Actions
import { startOrder, moveOrder, skipOrderCheck, getStepsAhead, getStepsBehind } from '../../../actions/orders'
import { updateOrderCheck } from '../../../actions/qualitychecksettings'

// Utils
import { getStepName } from '../../../utils/order'
import { formatCurrency, reverseFormatCurrency } from '../../../utils/currency'
import { translation, enumtranslate } from '../../../utils/helpers'

// Elements
import Button from '../../elements/button'
import LabelWrapper from '../../elements/labelWrapper'
import Text from '../../elements/text'
import Inline from '../../elements/inline'
import Divider from '../../elements/divider'

import { ModalIcons } from '../../elements/icons'

class QualityCheckModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      overflowHidden: false,
      confirm: false,
      data: {},
      rawData: [{}],
      PaintThickness: '',
      SelectedOrderFiles: [[]],
      WarrantyCode: '',
      photodocStart: false,
      photodocEnd: false,
      otherModalOpen: false,
      item: {
        Id: 0,
        StepId: 0,
        To: 0
      },
      validStepsAhead: [],
      validStepsBehind: []
    }
    this.renderGroup = this.renderGroup.bind(this)
    this.startOrder = this.startOrder.bind(this)
    this.acceptQualityCheck = this.acceptQualityCheck.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.closePhotoModal = this.closePhotoModal.bind(this)
    this.renderMultipleChecks = this.renderMultipleChecks.bind(this)
    this.renderQualityCheckMultiple = this.renderQualityCheckMultiple.bind(this)
    this.renderPaintThicknesses = this.renderPaintThicknesses.bind(this)
    this.onClose = this.onClose.bind(this)
    this.moveOrder = this.moveOrder.bind(this)
    this.renderPhotoSection = this.renderPhotoSection.bind(this)
    this.setCustomQualityCheckStatus = this.setCustomQualityCheckStatus.bind(this)
    this.renderCustomCheckMultiple = this.renderCustomCheckMultiple.bind(this)
    this.getValidSteps = this.getValidSteps.bind(this)
    this.validateMoveToStep = this.validateMoveToStep.bind(this)
    this.checkAllChecksPerformed = this.checkAllChecksPerformed.bind(this)
  }

  componentDidMount () {
    if (this.props.move === true) {
      let data = JSON.parse(JSON.stringify(this.props.data[0].Checks))
      data.shift()
      let dataChecks = this.props.data[0].Checks[0]
      let defaultLTW = this.state.WarrantyCode
      if (dataChecks.QualityChecks[0] && dataChecks.QualityChecks[0].DefaultLTWCode !== undefined) {
        defaultLTW = dataChecks.QualityChecks[0].DefaultLTWCode
      }
      this.setState({
        data: dataChecks,
        rawData: data,
        WarrantyCode: defaultLTW
      }, () => {
        let orderId = this.state.data.OrderId
        this.getValidSteps(orderId).then(() => {
          if (this.state.data.QualityChecks[0]) {
            this.setState({
              item: {
                Id: orderId,
                StepId: this.state.data.QualityChecks[0].StepId,
                To: this.validateMoveToStep(this.state.data.QualityChecks[this.state.data.QualityChecks.length - 1].StepId)
              }
            })
          } else if (this.state.data.ProcessComments[0]) {
            this.setState({
              item: {
                Id: orderId,
                StepId: this.state.data.ProcessComments[0].StepId,
                To: this.validateMoveToStep(this.state.data.ProcessComments[this.state.data.ProcessComments.length - 1].StepId)
              }
            })
          }
        })
      })
    } else if (this.props.data.res !== undefined) {
      let data = JSON.parse(JSON.stringify(this.props.data.res))
      data.shift()
      let dataRes = this.props.data.res[0]
      let defaultLTW = this.state.WarrantyCode
      if (dataRes !== undefined && dataRes !== null && dataRes.QualityCheck.DefaultLTWCode !== undefined) {
        defaultLTW = dataRes.QualityCheck.DefaultLTWCode
      }
      this.setState({
        data: dataRes,
        rawData: data,
        WarrantyCode: defaultLTW
      }, () => {
        this.setState({
          item: {
            Id: this.state.data.QualityCheck.OrderId,
            StepId: this.state.data.QualityCheck.StepId,
            To: this.state.data.QualityCheck.StepId
          }
        }, () => {
          this.getValidSteps(this.state.item.Id)
        })
      })
    } else {
      this.props.onClose()
    }
  }

  getValidSteps (orderId) {
    let ahead = this.props.getStepsAhead(orderId, false).then((res) => { this.setState({ validStepsAhead: res.data }) })
    let behind = this.props.getStepsBehind(orderId, false).then((res) => { this.setState({ validStepsBehind: res.data }) })
    return Promise.all([ahead, behind])
  }

  /**
   * Checks that the step is valid to move to. If not, the next step after current step will be returned.
   * @param {*} step
   */
  validateMoveToStep (step) {
    if (typeof step === 'string') step = parseInt(step)
    let indexAhead = this.state.validStepsAhead.findIndex(s => s.Step === step)
    let indexBehind = this.state.validStepsBehind.findIndex(s => s.Step === step)
    let adjustedStep = step
    if (indexAhead === -1 && indexBehind === -1) {
      adjustedStep = this.state.validStepsAhead[0].Step
    }
    return adjustedStep
  }

  // Paint = 1
  // Quality check = 2
  // Photo = 3
  // Garanti = 4
  // Custom = 5

  renderProcessComments () {
    let { ProcessComments } = this.state.data
    // Check if theres any comments
    let anyComments = false
    ProcessComments.map((val) => {
      if (val.StepComments.length !== 0) anyComments = true
    })
    if (!anyComments) return null
    // Render process step
    const renderProcessStep = (item, key) => {
      if (item.StepComments.length === 0) return null
      return (
        <div key={key} className='processCommentItem'>
          <strong>{translation(getStepName(item.StepId))}</strong>
          {item.StepComments.map((v, idx) => {
            let text = (v.StartOrEnd === 1) ? translation('271') + ' - ' : translation('2062') + ' - '
            if (v.StartOrEnd === 3) text = ''
            return <div key={idx}>{text}{v.Comment}</div>
          })}
        </div>
      )
    }
    return (
      <div className='qualityGroup'>
        <strong>{translation('1925')}</strong>
        {ProcessComments.map(renderProcessStep)}
      </div>
    )
  }

  renderMultipleChecks () {
    let paintThicknesses = []
    let photoChecks = []
    let warrantyFailed = false
    let checks = []
    let customChecks = []

    this.state.data.QualityChecks.map((val) => {
      val.CheckStatus.map((v, index) => {
        let checkStart = true
        let checkEnd = true

        if ((checkStart || checkEnd) && !v.IsEndPerformed || !v.IsStartPerformed) {
          switch (v.QualityCheckTaskType) {
            case 1:
              if (typeof paintThicknesses[val.StepId] === 'undefined') {
                paintThicknesses[val.StepId] = []
              }
              v.OrderId = val.OrderId
              if (checkStart && !v.IsStartPerformed) {
                let v1 = { ...v }
                v1.checkType = 'Start'
                paintThicknesses[val.StepId].push(v1)
              }
              if (checkEnd && !v.IsEndPerformed) {
                let v2 = { ...v }
                v2.checkType = 'End'
                paintThicknesses[val.StepId].push(v2)
              }
              break
            case 2:
              if (typeof checks[val.StepId] === 'undefined') {
                checks[val.StepId] = []
              }
              v.OrderId = val.OrderId
              if (checkStart && !v.IsStartPerformed) {
                let v1 = { ...v }
                v1.checkType = 'Start'
                checks[val.StepId].push(v1)
              }
              if (checkEnd && !v.IsEndPerformed) {
                let v2 = { ...v }
                v2.checkType = 'End'
                checks[val.StepId].push(v2)
              }
              break
            case 3:
              if (typeof photoChecks[val.StepId] === 'undefined') {
                photoChecks[val.StepId] = []
              }
              v.OrderId = val.OrderId
              if (checkStart && !v.IsStartPerformed) {
                let v1 = { ...v }
                v1.checkType = 'Start'
                photoChecks[val.StepId].push(v1)
              }
              if (checkEnd && !v.IsEndPerformed) {
                let v2 = { ...v }
                v2.checkType = 'End'
                photoChecks[val.StepId].push(v2)
              }
              break
            case 4:
              warrantyFailed = true
              break
            case 5:
              if (typeof customChecks[val.StepId] === 'undefined') {
                customChecks[val.StepId] = []
              }
              v.OrderId = val.OrderId
              if (checkStart && !v.IsStartPerformed) {
                let v1 = { ...v }
                v1.checkType = 'Start'
                v1.index = index
                v1.StepId = val.StepId
                customChecks[val.StepId].push(v1)
              }
              if (checkEnd && !v.IsEndPerformed) {
                let v2 = { ...v }
                v2.checkType = 'End'
                v2.index = index
                v2.StepId = val.StepId
                customChecks[val.StepId].push(v2)
              }
              break
          }
        }
      })
    })

    return (
      <div>
        {paintThicknesses.map(this.renderPaintThicknesses)}
        {checks.map(this.renderQualityCheckMultiple)}
        {photoChecks.map(this.renderPhotoSection)}
        {warrantyFailed && this.renderWarrantyCode('warranty_0')}
        {customChecks.map(this.renderCustomCheckMultiple)}
      </div>
    )
  }

  renderGroup (item, key) {
    if (item.IsStartPerformed) return null
    switch (item.QualityCheckTaskType) {
      case 1:
        return this.renderPaintThickness(item, key)
      case 2:
        return this.renderQualityCheck(item, key)
      case 3:
        return this.renderPhotoSection(item, key)
      case 4:
        return this.renderWarrantyCode(key)
      case 5:
        return this.renderCustomChecks(item, key)
      default:
        return null
    }
  }

  onChange (e) {
    let name = e.target.name
    let value = e.target.value
    this.setState({
      [name]: value
    })
  }

  onBlur (e) {
    let value = formatCurrency(parseFloat(reverseFormatCurrency(e.target.value)))
    this.setState({
      [e.target.name]: value
    })
  }

  renderPaintThickness (item, key) {
    return (
      <LabelWrapper key={key} labelText={translation('370')}>
        <Text value={this.state.PaintThickness} name='PaintThickness' onChange={this.onChange} onBlur={this.onBlur} />
      </LabelWrapper>
    )
  }

  renderPaintThicknesses (item, key) {
    if (item.length === 0) return null
    const renderPaint = (itm, k) => {
      let type = itm.checkType
      let ref = key + '_' + type + '_paint'
      type = type === 'End' ? '2062' : '1223'
      const onBlur = (e) => {
        let value = formatCurrency(parseFloat(reverseFormatCurrency(e.target.value)))
        this.refs[ref].value = value
      }
      return (
        <div key={k} className='multipleQualityCheck'>
          <div className='helperText'>{translation(type)}</div>
          <Text onBlur={onBlur} ref={ref} data-step={key} />
        </div>
      )
    }
    return (
      <LabelWrapper key={key} labelText={translation('370') + ' - ' + translation(getStepName(key))}>
        {item.map(renderPaint)}
      </LabelWrapper>
    )
  }

  goToDeviation () {
    if (this.state.item.StepId === 2) {
      this.props.router.push('/pricecalculation/' + this.state.item.Id + '/6')
    } else {
      this.props.router.push('/pricecalculation/' + this.state.item.Id + '/5')
    }
    this.props.onClose()
  }

  renderQualityCheckMultiple (item, key) {
    if (item.length === 0) return null
    const renderCheck = (itm, k) => {
      let type = itm.checkType
      type = type === 'End' ? '2062' : '1223'
      let deviationTextId = '310'
      if (this.state.item.StepId === 2) {
        deviationTextId = '311'
      }
      return (
        <div key={k} className='multipleQualityCheck'>
          <div className='helperText'>{translation(type)}</div>
          <Inline block fillChildNum={[0, 1]} fullWidth>
            <Button style='link' onClick={this.acceptQualityCheck.bind(this, itm.OrderId, key, itm)} labelText={translation('956')} />
            <Button style='link' onClick={this.goToDeviation.bind(this)} labelText={translation(deviationTextId)} />
          </Inline>
        </div>
      )
    }
    return (
      <LabelWrapper key={key} labelText={translation('342') + ' - ' + translation(getStepName(key))}>
        {item.map(renderCheck)}
      </LabelWrapper>
    )
  }

  renderQualityCheck (item, key) {
    let deviationTextId = '310'
    if (this.state.item.StepId === 2) {
      deviationTextId = '311'
    }
    return (
      <LabelWrapper key={key} labelText={translation('342')}>
        <Inline block fillChildNum={[0, 1]} fullWidth>
          <Button style='link' onClick={this.acceptQualityCheck.bind(this, undefined, undefined, undefined)} labelText={translation('956')} />
          <Button style='link' onClick={this.goToDeviation.bind(this)} labelText={translation(deviationTextId)} />
        </Inline>
      </LabelWrapper>
    )
  }

  acceptQualityCheck (orderId, stepId, item) {
    let updateStart = false
    let updateEnd = true
    let orderCheckId = 0
    let stepFrom = 0
    let stepTo = 0
    let orderNoteStart = ''
    let orderNoteEnd = ''
    let statusAtStart = 0
    let statusAtEnd = 0
    let qualityCheckTaskType = 2
    let qualityCheckTaskId = null // Regular QualityCheck tasks use the tasktype for identifying. Custom checks has to use the task id, since multiple tasks in same step can have same type.
    if (typeof orderId === 'undefined') {
      orderId = this.state.data.QualityCheck.OrderId
      stepId = this.state.data.QualityCheck.StepId
      updateStart = true
      updateEnd = false
    }
    // If data comes from item:
    if (typeof item !== 'undefined') {
      orderCheckId = item.OrderCheckId
      if (item.checkType === 'Start') {
        updateStart = true
        updateEnd = false
      } else {
        updateStart = false
        updateEnd = true
      }
      stepFrom = this.state.item.StepId

      // Apparently the 'To' step can come from item in state or from props
      stepTo = this.state.item.To
      if (Array.isArray(this.props.data) && this.props.data[0] !== undefined && this.props.data[0].StepTo !== undefined) {
        stepTo = this.props.data[0].StepTo
      }

      orderNoteStart = item.OrderNoteStart
      orderNoteEnd = item.OrderNoteEnd
      statusAtStart = item.StatusAtStart
      statusAtEnd = item.StatusAtEnd
      qualityCheckTaskType = item.QualityCheckTaskType
      qualityCheckTaskId = item.QualityCheckTaskId
    }

    // Validate target step.
    stepTo = this.validateMoveToStep(stepTo)

    // Gather data to send in request.
    let data = {
      OrderCheckId: orderCheckId,
      OrderId: orderId,
      StepId: stepId,
      UpdateStart: updateStart,
      UpdateEnd: updateEnd,
      StepFrom: stepFrom,
      StepTo: stepTo,
      OrderNoteStart: orderNoteStart,
      OrderNoteEnd: orderNoteEnd,
      StatusAtStart: statusAtStart,
      StatusAtEnd: statusAtEnd,
      QualityCheckTaskType: qualityCheckTaskType,
      QualityCheckTaskId: qualityCheckTaskId
    }

    this.props.updateOrderCheck(data).then((res) => {
      // 2 cases when doing order checks: Either user is trying to move an order, or trying to start it.
      if (this.props.move) {
        this.setState({
          data: {
            ...this.state.data,
            QualityChecks: res.data
          }
        }, () => {
          // If all checks have been performed, attempt to move order.
          let allChecksPerformed = this.checkAllChecksPerformed(this.state.data.QualityChecks)
          if (allChecksPerformed) {
            this.moveOrder(false)
          }
        })
      } else {
        this.setState({
          data: {
            ...this.state.data,
            QualityCheck: res.data[0]
          }
        }, () => {
          this.startOrder()
        })
      }
    }, () => {
      console.log('Error updating quality check')
    })
  }

  checkAllChecksPerformed (qualityCheckData) {
    let qualityChecks = qualityCheckData
    let allChecksPerformed = true
    for (let q = 0; q < qualityChecks.length; q++) {
      if (qualityChecks[q].EndFailed || qualityChecks[q].StartFailed) {
        allChecksPerformed = false
        break
      }
      for (let c = 0; c < qualityChecks[q].CheckStatus; c++) {
        let status = qualityChecks[q].CheckStatus[c]
        if (!status.IsStartPerformed || !status.IsEndPerformed) {
          allChecksPerformed = false
          break
        }
      }
    }
    return allChecksPerformed
  }

  renderPhotoSection (item, key) {
    if (item.length === 0) return null
    const renderPhotoD = (itm, k) => {
      const openPhotoDoc = () => {
        this.setState({
          photodocStart: itm.checkType === 'Start',
          photodocEnd: itm.checkType === 'End',
          stepId: key,
          otherModalOpen: true
        })
      }
      let type = itm.checkType
      type = type === 'End' ? '2062' : '1223'
      return (
        <Button style='link' key={k} onClick={openPhotoDoc.bind(this)} labelText={translation('2065') + ' - ' + translation(type)} />
      )
    }
    if (item.length > 0 && item.map !== undefined) { // Multiple photo checks
      return (
        <LabelWrapper key={key} labelText={translation('2065') + ' - ' + translation(getStepName(key))}>
          {item.map(renderPhotoD)}
        </LabelWrapper>
      )
    }
    // Single photo check
    const openPhoto = () => {
      this.setState({
        photodocStart: true,
        photodocEnd: false,
        otherModalOpen: true
      })
    }
    return (
      <LabelWrapper key={key} labelText={translation('2065')}>
        <Button onClick={openPhoto.bind(this)} labelText={translation('2065')} style='link' />
      </LabelWrapper>
    )
  }

  renderWarrantyCode (key) {
    return (
      <LabelWrapper key={key} labelText={translation('13396')}>
        <Text value={this.state.WarrantyCode} name='WarrantyCode' onChange={this.onChange} />
      </LabelWrapper>
    )
  }

  renderCustomCheckMultiple (item, key) {
    if (item.length === 0) return null
    const renderCheck = (itm, k) => {
      let type = itm.checkType
      let name = itm.index + '_' + type
      type = type === 'End' ? '2062' : '1223'
      const onChange = (e) => {
        let nameString = e.target.name.split('_')
        let index = parseInt(nameString[0])
        let noteType = nameString[1] === 'Start' ? 'OrderNoteStart' : 'OrderNoteEnd'
        let checkStatuses = this.state.data.QualityChecks[0].CheckStatus
        checkStatuses[index][noteType] = e.target.value
        let qualityChecks = this.state.data.QualityChecks
        qualityChecks[0].CheckStatus = checkStatuses
        this.setState({
          data: {
            ...this.state.data,
            QualityChecks: [ ...qualityChecks ]
          }
        })
      }
      let label = itm.QualityCheckTaskName + ' - ' + translation(getStepName(itm.StepId))
      return (
        <LabelWrapper key={k} labelText={label} className='multipleQualityCheck-custom'>
          <div className='helperText'>{translation(type)}</div>
          <Text name={name} onChange={onChange} value={itm.Note} />
          <Inline block fillChildNum={[0, 1]} fullWidth>
            <Button style='link' onClick={this.setCustomQualityCheckStatus.bind(this, itm, 2, itm.checkType, key)} labelText={translation('1141')} />
            <Button style='link' onClick={this.setCustomQualityCheckStatus.bind(this, itm, 1, itm.checkType, key)} labelText={translation('17855')} />
          </Inline>
        </LabelWrapper>
      )
    }
    return (
      <div key={key}>
        {item.map(renderCheck)}
      </div>
    )
  }

  renderCustomChecks (item, key) {
    const STATUS_APPROVED = 2
    const STATUS_NOT_APPROVED = 1
    let type
    if (!item.IsEndPerformed) type = 'End'
    if (!item.IsStartPerformed) type = 'Start'

    const onChange = (e) => {
      item[e.target.name] = e.target.value
      this.setState({
        ...this.state.data.QualityCheck.CheckStatus
      })
    }

    return (
      <div key={key}>
        <LabelWrapper labelText={item.QualityCheckTaskName} className='multipleQualityCheck-custom'>
          {type === 'Start' && <Text value={item.OrderNoteStart || ''} name='OrderNoteStart' onChange={onChange} />}
          {type === 'End' && <Text value={item.OrderNoteEnd || ''} name='OrderNoteEnd' onChange={onChange} />}
          <Inline block fillChildNum={[0, 1]} fullWidth>
            <Button style='link' onClick={this.setCustomQualityCheckStatus.bind(this, item, STATUS_APPROVED, type, item)} labelText={translation('1141')} />
            <Button style='link' onClick={this.setCustomQualityCheckStatus.bind(this, item, STATUS_NOT_APPROVED, type, item)} labelText={translation('17855')} />
          </Inline>
        </LabelWrapper>
      </div>
    )
  }

  setCustomQualityCheckStatus (item, status, type, key) {
    if (type === 'End') {
      item.StatusAtEnd = status
      item.UpdateEnd = true
    } else {
      item.StatusAtStart = status
      item.UpdateStart = true
    }
    item.checkType = type
    this.acceptQualityCheck(item.OrderId, key, item)
  }

  startOrder (CheckOnly) {
    let PaintThickness = (this.state.PaintThickness === '') ? 0 : parseFloat(reverseFormatCurrency(this.state.PaintThickness))
    let data = {
      Orders: [
        {
          OrderId: this.state.data.QualityCheck.OrderId,
          WarrantyCode: this.state.WarrantyCode,
          PaintThickness: PaintThickness
        }
      ],
      UserIds: this.props.data.UserIds,
      WorkOnAll: this.props.data.WorkOnAll,
      CheckOnly: true
    }

    for (let i = 0; i < this.state.rawData.length; i++) {
      if (this.state.item.Id === this.state.rawData[i].OrderId) continue

      let order = {
        OrderId: this.state.rawData[i].OrderId,
        WarrantyCode: ''
      }
      data.Orders.push(order)
    }

    this.props.startOrder(data).then((res) => {
      if (res.data.filter(x => x.QualityCheck.StartFailed === true).length === 0) {
        // let message = data.Orders.length > 1 ? translation('13519') : translation('13518')
        // window.toastr.success(message, translation('13424'))
        this.props.onClose()
        return null
      }
      this.setState({
        PaintThickness: '',
        WarrantyCode: '',
        data: res.data[0]
      }, () => {
        this.setState({
          item: {
            Id: this.state.data.QualityCheck.OrderId,
            StepId: this.state.data.QualityCheck.StepId,
            To: this.validateMoveToStep(this.state.data.QualityCheck.StepId)
          }
        })
      })
    }, () => {
      let message = data.Orders.length > 1 ? translation('12337') : translation('1923')
      window.toastr.error(message, translation('216'))
    })
  }

  moveOrder (CheckOnly) {
    let paintThicknesses = []
    Object.keys(this.refs).map((val) => {
      if (this.refs[val].value !== '') {
        let UpdateEnd = (val.indexOf('End') !== -1)
        let UpdateStart = (val.indexOf('Start') !== -1)
        paintThicknesses.push({
          StepId: parseInt(this.refs[val].props['data-step']),
          PaintThickness: parseFloat(reverseFormatCurrency(this.refs[val].value)),
          UpdateEnd: UpdateEnd,
          UpdateStart: UpdateStart
        })
      }
    })

    let orders = [{
      OrderId: this.state.item.Id,
      PaintThicknesses: paintThicknesses,
      WarrantyCode: this.state.WarrantyCode
    }]

    for (let i = 0; i < this.props.data[0].OrderIds.length; i++) {
      if (this.state.item.Id === this.props.data[0].OrderIds[i]) continue

      let order = {
        OrderId: this.props.data[0].OrderIds[i],
        WarrantyCode: ''
      }
      orders.push(order)
    }

    // Apparently the 'To' step can come from item in state or from props
    let stepTo = this.state.item.To
    if (Array.isArray(this.props.data) && this.props.data[0] !== undefined && this.props.data[0].StepTo !== undefined) {
      stepTo = this.props.data[0].StepTo
    }

    let moveData = {
      Orders: orders,
      UserId: 0,
      MoveAll: false,
      StepFrom: this.state.item.StepId,
      StepTo: this.validateMoveToStep(stepTo),
      Comment: '',
      FilterSettings: {},
      CheckOnly: CheckOnly,
      DontReturnOrders: (stepTo === 8)
    }

    this.props.moveOrder(moveData).then((res) => {
      if (!res.data.MoveFailed) {
        if (CheckOnly) {
          this.moveOrder(false)
        } else {
          // let message = orders.length > 1 ? translation('12338') : translation('1909')
          // window.toastr.success(message, translation('13424'))
          if (this.props.onMoveSuccess !== undefined) {
            this.props.onMoveSuccess(res.data, orders)
          }
          this.props.onClose()
          return null
        }
      }

      let element = document.getElementsByClassName('modal--content clearfix')[0]
      let inputs = element.getElementsByTagName('input')
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].value = ''
      }
      if (this.state.data.QualityChecks[0] && res.data.Checks[0]) {
        let defaultLTW = ''
        let dataChecks = res.data.Checks[0]
        if (dataChecks !== undefined && dataChecks.QualityChecks[0] && dataChecks.QualityChecks[0].DefaultLTWCode !== undefined) {
          defaultLTW = dataChecks.QualityChecks[0].DefaultLTWCode
        }
        this.setState({
          PaintThickness: '',
          WarrantyCode: defaultLTW,
          data: res.data.Checks[0],
          item: {
            Id: res.data.Checks[0].OrderId, // need to be from res, to handle mass order move
            StepId: this.state.data.QualityChecks[0].StepId,
            To: this.validateMoveToStep(this.state.data.QualityChecks[this.state.data.QualityChecks.length - 1].StepId)
          }
        })
      } else if (this.state.data.ProcessComments[0]) {
        this.setState({
          PaintThickness: '',
          WarrantyCode: '',
          data: res.data.Checks[0],
          item: {
            Id: this.state.data.OrderId,
            StepId: this.state.data.ProcessComments[0].StepId,
            To: this.validateMoveToStep(this.state.data.ProcessComments[this.state.data.ProcessComments.length - 1].StepId)
          }
        })
      }
    }, (res) => {
      // Toastr
      let message
      if (res.response.data.IsStopped === true) message = translation('12347')
      else if (res.response.data.IsReffered === true) message = translation('2704')
      else message = orders.length > 1 ? translation('12339') : translation('1731')
      window.toastr.error(message, translation('216'))
    })
  }

  stepHasComments (data) {
    let ProcessComments = data.ProcessComments
    let anyComments = false
    if (ProcessComments === undefined) {
      data.Checks.map((check) => {
        check.ProcessComments.map((val) => {
          if (val.StepComments.length !== 0) {
            anyComments = true
          }
        })
      })
    } else {
      ProcessComments.map((val) => {
        if (val.StepComments.length !== 0) anyComments = true
      })
    }

    return anyComments
  }

  sumQCchecks (checks) {    // :()
    var checkStatuses = []
    checks.map(x => {
      var index = checkStatuses.findIndex(y => y.QualityCheckTaskType === 5 && x.QualityCheckTaskType === 5 && y.QualityCheckTaskId === x.QualityCheckTaskId || y.QualityCheckTaskType !== 5 && y.QualityCheckTaskType === x.QualityCheckTaskType)
      if (index >= 0) {
        checkStatuses[index].IsEndPerformed = (checkStatuses[index].IsEndPerformed && x.IsEndPerformed)
        checkStatuses[index].IsStartPerformed = (checkStatuses[index].IsStartPerformed && x.IsStartPerformed)
        checkStatuses[index].HasMultipule = true
      } else {
        checkStatuses.push(x)
      }
    })

    return checkStatuses
  }

  renderView () {
    if (this.state.data === undefined) return null
    if (Object.keys(this.state.data).length === 0) return null
    // Button
    let groupName = '1928'
    let button = <Button onClick={this.startOrder.bind(this, false)} labelText={translation('1928')} style='link' />
    if (this.props.move) {
      button = <Button onClick={this.moveOrder.bind(this, false)} labelText={translation('709')} style='link' />
      groupName = '709'
    }
    // Checks
    if (this.props.move) {
      if (!this.state.data.MoveFailed && !this.stepHasComments(this.state.data)) {
        return (
          <div>
            {translation('1927')}
          </div>
        )
      }
      if (!this.state.data.MoveFailed) {
        button = <Button onClick={this.onClose.bind(this, false)} labelText={translation('956')} style='link' />
      }
    } else {
      if (!this.state.data.QualityCheck.StartFailed && !this.stepHasComments(this.state.data)) {
        return (
          <div>
            {translation('1926')}
          </div>
        )
      }
      if (!this.state.data.QualityCheck.StartFailed) {
        button = <Button onClick={this.onClose.bind(this, false)} labelText={translation('1928')} style='link' />
      }
    }

    // Return
    return (
      <div>
        {this.renderProcessComments()}
        {!this.props.move && this.sumQCchecks(this.state.data.QualityCheck.CheckStatus).map(this.renderGroup)}
        {this.props.move && this.renderMultipleChecks()}
        {button !== '' && <Divider size={3} noLine />}
        {button !== '' && (
          <LabelWrapper className='qualityGroup' labelText={translation(groupName)}>
            {button}
          </LabelWrapper>
        )}
      </div>
    )
  }

  closePhotoModal () {
    this.setState({
      photodocStart: false,
      photodocEnd: false,
      otherModalOpen: false
    })
  }

  onClosePortal () { }

  onClose () {
    let { data } = this.state
    if (this.props.move) {
      let moveData = {
        MoveFailed: data.MoveFailed,
        StepTo: this.state.item.To,
        StepFrom: this.state.item.StepId
      }
      let orders = [{
        OrderId: data.OrderId
      }]
      // let message = translation('1909')
      if (!this.state.data.MoveFailed && !this.stepHasComments(this.state.data)) {
        // window.toastr.success(message, translation('13424'))
      }
      this.props.onClose()
      if (!this.props.onlyProcessComments) {
        this.props.onMoveSuccess(moveData, orders)
      }
    } else {
      if (data.QualityCheck.StartFailed || data.QualityCheck.EndFailed) {
        this.setState({
          confirm: true
        })
      } else {
        this.props.onClose()
      }
    }
  }

  render () {
    // Confirm
    const onPortalClose = () => {
      this.setState({
        confirm: false
      })
    }
    const onConfirm = () => {
      this.setState({
        confirm: false
      }, () => {
        let data = {
          OrderId: this.state.item.Id,
          StepId: this.state.item.StepId
        }
        this.props.skipOrderCheck(data)
        this.props.onClose()
      })
    }
    const confirmText = (props) => {
      return (
        <div>
          {props.t('2199')}
        </div>
      )
    }
    const setImages = () => {
      if (this.props.move) {
        this.moveOrder(true)
      } else {
        this.startOrder(true)
      }
    }
    // Return
    return (
      <div>
        <Portal dontSendT onPortalClose={this.onClosePortal} className='qualityModalOuterPortal'>
          <div className='qualityModalOuter'>
            <div className='quality__modal'>
              <Modal {...this.props}
                hideContainer={this.state.otherModalOpen}
                header={translation('1929') + (this.state.data !== undefined ? (this.state.data.Title === undefined ? '' : ' ' + this.state.data.Title) : '')}
                overflowHidden={this.state.overflowHidden}
                onClose={this.onClose}
                icon={ModalIcons.Quality_Check}
                t={translation}>
                {this.renderView()}
              </Modal>
            </div>
            {this.state.photodocStart && (
              <PhotoDocModal
                stepId={this.state.stepId}
                show={this.state.photodocStart}
                item={this.state.item}
                onClose={this.closePhotoModal}
                store={store}
                setImages={setImages.bind(this)}
                QualityCheckPhotoStart
                t={translation}
                enumfunc={enumtranslate} />
            )}
            {this.state.photodocEnd && (
              <PhotoDocModal
                stepId={this.state.stepId}
                show={this.state.photodocEnd}
                item={this.state.item}
                onClose={this.closePhotoModal}
                store={store}
                setImages={setImages.bind(this)}
                QualityCheckPhotoEnd
                t={translation}
                enumfunc={enumtranslate} />
            )}
          </div>
        </Portal>
        {this.state.confirm !== false && (
          <Portal className='confirmModal' onPortalClose={onPortalClose}>
            <Confirm confirm={onConfirm} notConfirm={onPortalClose} higher renderText={confirmText} />
          </Portal>
        )}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  updateOrderCheck,
  startOrder,
  moveOrder,
  skipOrderCheck,
  getStepsAhead,
  getStepsBehind
})(QualityCheckModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/QualityCheckModal/index.js